<script setup lang="ts"></script>

<template>
  <div class="flex items-center">
    <slot></slot>
  </div>
</template>

<style scoped lang="css"></style>
